// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseUnreachableCluster
 */
export interface ResponseUnreachableCluster {
  /**
   *
   * @type {string}
   * @memberof ResponseUnreachableCluster
   */
  clusterName?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseUnreachableCluster
   */
  reason?: string;
}

/**
 * Check if a given object implements the ResponseUnreachableCluster interface.
 */
export function instanceOfResponseUnreachableCluster(
  value: object,
): value is ResponseUnreachableCluster {
  return true;
}

export function ResponseUnreachableClusterFromJSON(
  json: any,
): ResponseUnreachableCluster {
  return ResponseUnreachableClusterFromJSONTyped(json, false);
}

export function ResponseUnreachableClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseUnreachableCluster {
  if (json == null) {
    return json;
  }
  return {
    clusterName: json['clusterName'] == null ? undefined : json['clusterName'],
    reason: json['reason'] == null ? undefined : json['reason'],
  };
}

export function ResponseUnreachableClusterToJSON(
  json: any,
): ResponseUnreachableCluster {
  return ResponseUnreachableClusterToJSONTyped(json, false);
}

export function ResponseUnreachableClusterToJSONTyped(
  value?: ResponseUnreachableCluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusterName: value['clusterName'],
    reason: value['reason'],
  };
}
